"use client"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"
import { UserIcon } from "@/src/shared/assets/icons"

const frames = {
  xs: {
    root: "size-6 rounded-[5px] border-[1px] p-px",
    image: "size-full rounded-[3px]",
    fallback: "size-full rounded-[3px]",
    icon: "size-3"
  },
  sm: {
    root: "size-9",
    image: "size-7",
    icon: "size-4"
  },
  md: {
    root: "size-11 xl:size-[52px]",
    image: "size-9 xl:size-11",
    icon: "size-5 xl:size-6"
  },
  xl: {
    root: "size-[140px] p-0.5 shadow-[1px_5px_6px_--theme(--color-black/25%)]",
    image: "size-full rounded-md object-cover",
    fallback: "size-full rounded-md",
    icon: "size-12"
  }
} as const

type UserAvatarProps = {
  src?: string | null
  alt?: string
  size?: keyof typeof frames
  className?: string
}

export function UserAvatar({
  src,
  alt = "",
  size = "md",
  className
}: UserAvatarProps) {
  const frame = frames[size]
  const photo = src?.trim()

  return (
    <Avatar
      className={cn(
        "border-success-470",
        frame.root,
        className
      )}
    >
      {photo ? (
        <AvatarImage src={photo} alt={alt} className={frame.image} />
      ) : null}
      <AvatarFallback
        className={cn(
          "text-white/70",
          "fallback" in frame && frame.fallback
        )}
      >
        <UserIcon className={frame.icon} aria-hidden />
      </AvatarFallback>
    </Avatar>
  )
}
